import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
// import {
//   Search as SearchIcon,
//   DoubleArrow as DoubleArrowIcon,
//   CheckCircle as CheckCircleIcon
// } from '@material-ui/icons';
import { joinClasses, callService } from 'utils/utility';
import { errorAlert, warningAlert } from 'utils/alert';
import { calvh, clickAnime } from 'utils/element';
import { getStudentStudy } from 'services/student-study';
import { useImagesContext } from 'contexts/ImagesContext';
import Comment from 'components/fragments/Comment';
import ButtonBack from 'components/fragments/ButtonBack';
import Progress from 'components/fragments/Progress';
import { Carousel } from 'antd';
//import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
  },
  'carousel-container': {
    zIndex: 1,
    width: '100%',
    height: 'auto',
    '& [class~="ant-carousel"] [class~="slick-dots"] button': {
      background: '#9798aa !important',
    },
    '& [class~="ant-carousel"] [class~="slick-dots"] [class~="slick-active"] button':
      {
        background: '#adaeb6 !important',
      },
    '& [class~="ant-carousel"] [class~="slick-dots"]': {
      display: 'none !important',
    },
  },
  'student-study-comment': {
    maxHeight: calvh('3.5vh'),
    '@media (min-width:434px)': {
      //maxHeight: calvh('5vh'),
    },
    '@media (max-width:350px)': {
      //maxHeight: calvh('4vh'),
    },
    objectFit: 'contain',
  },
  'label-date': {
    fontSize: calvh('3.8vh'),
    lineHeight: calvh('3.8vh'),
    color: '#000',
    textShadow: `#fff ${calvh('0.1vh')} ${calvh('0.1vh')} 0px, #fff ${calvh(
      '-0.1vh'
    )} ${calvh('0.16vh')} 0px, #fff 0px ${calvh('-0.16vh')} 0px, #000 ${calvh(
      '0.1vh'
    )} ${calvh('0.1vh')} 0px`,
    //paddingBottom: '5px',
  },
  'text-study': {
    fontSize: calvh('4vh'),
    lineHeight: calvh('4vh'),
    color: '#000',
    textShadow: `#fff ${calvh('0.1vh')} ${calvh('0.1vh')} 0px, #fff ${calvh(
      '-0.1vh'
    )} ${calvh('0.16vh')} 0px, #fff 0px ${calvh('-0.16vh')} 0px, #000 ${calvh(
      '0.1vh'
    )} ${calvh('0.1vh')} 0px`,
    alignSelf: 'center',
  },
  'container-devider': {
    width: '100%',
    height: '.2rem',
    backgroundColor: '#7d4c08',
  },
  'student-study-prev': {
    position: 'fixed',
    zIndex: 2,
    left: '91vw',
    top: calvh('9vh'),

    height: calvh('8vh'),
    maxWidth: '8vw',
    objectFit: 'contain',
    objectPosition: '0% 0%',
  },
  'student-study-next': {
    position: 'fixed',
    zIndex: 2,
    left: '91vw',
    bottom: calvh('3vh'),

    height: calvh('8vh'),
    maxWidth: '8vw',
    objectFit: 'contain',
    objectPosition: '0% 0%',
  },
}));

const DEFAULT_STUDY_PAGE = 0;
const DEFAULT_STUDY_ROWS_PER_PAGE = 4;

const StudentStudy = (props) => {
  const { images } = useImagesContext();
  const c = joinClasses(useStyles({ ...props }));
  const [getStudentStudyFlag, setGetStudentStudyFlag] = React.useState({});
  const [studentStudys, setStudentStudys] = React.useState([]);
  const [studyPagination, setStudyPagination] = React.useState({
    rowsPerPage: DEFAULT_STUDY_ROWS_PER_PAGE,
    page: DEFAULT_STUDY_PAGE,
  });
  const refStudyCarousel = React.useRef(null);

  React.useEffect(() => {
    handleGetStudentStudy();
  }, []);

  const handleCommentCarouselAfterChangePage = (newPage) => {};

  const handleClickStudyPrev = () => {
    refStudyCarousel.current && refStudyCarousel.current.prev();
    if (studyPagination?.page > 0) {
      setStudyPagination((prev) => ({ ...prev, page: prev.page - 1 }));
    } else {
      setStudyPagination((prev) => ({
        ...prev,
        page:
          Math.ceil(
            (studentStudys || []).length / DEFAULT_STUDY_ROWS_PER_PAGE
          ) - 1,
      }));
    }
  };

  const handleClickStudyNext = () => {
    refStudyCarousel.current && refStudyCarousel.current.next();
    if (
      studyPagination?.page <
      Math.ceil((studentStudys || []).length / DEFAULT_STUDY_ROWS_PER_PAGE) - 1
    ) {
      setStudyPagination((prev) => ({ ...prev, page: prev.page + 1 }));
    } else {
      setStudyPagination((prev) => ({ ...prev, page: 0 }));
    }
  };

  const handleGetStudentStudy = (next) => {
    callService(
      getStudentStudy,
      {},
      setGetStudentStudyFlag,
      (resp) => {
        setStudentStudys(resp);
        next && next(resp);
      },
      (error) => {
        errorAlert(error);
      }
    );
  };

  const pendingFlag = React.useMemo(
    () => getStudentStudyFlag.request,
    [getStudentStudyFlag.request]
  );

  const successFlag = React.useMemo(
    () => getStudentStudyFlag.success,
    [getStudentStudyFlag.success]
  );

  return (
    <div className={c('root')}>
      <Grid
        container
        direction='column'
        justifyContent='space-between'
        alignItems='center'
        style={{ height: '100%' }}
      >
        <Grid
          item
          container
          justifyContent='center'
          alignItems='flex-start'
          alignContent='flex-start'
          style={{ marginTop: '0.5rem' }}
        >
          {pendingFlag ? (
            <Progress />
          ) : successFlag ? (
            <>
              <Grid item xs={11} container>
                <img
                  style={{
                    height: calvh('4vh'),
                    maxWidth: '28vw',
                    objectFit: 'contain',
                  }}
                  src={images[`student-study-comment.png`]}
                />
                <Grid
                  item
                  xs={12}
                  container
                  justifyContent='center'
                  style={{ padding: '5px 0px' }}
                >
                  <div className={c('container-devider')} />
                </Grid>
              </Grid>
              <Grid
                item
                xs={11}
                container
                style={{
                  // height: calvh('79vh'),
                  // overflow: 'hidden',
                  position: 'relative',
                }}
              >
                <div className={c('carousel-container')}>
                  <Carousel
                    afterChange={handleCommentCarouselAfterChangePage}
                    ref={refStudyCarousel}
                    dotPosition='right'
                  >
                    {Array.from(
                      Array(
                        Math.ceil(
                          (studentStudys || []).length /
                            DEFAULT_STUDY_ROWS_PER_PAGE
                        )
                      ).keys()
                    ).map((_, pidx) => {
                      const page = pidx;
                      const pageSize = studyPagination.rowsPerPage;
                      const trainersFilter = (studentStudys || []).slice(
                        page * pageSize,
                        page * pageSize + pageSize
                      );
                      return (
                        <div key={`study-page-` + pidx}>
                          <div
                            style={{
                              height: calvh('79vh'),
                              overflow: 'auto',
                            }}
                          >
                            {(trainersFilter || []).map((study) => (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  flexFlow: 'column',
                                }}
                              >
                                <div className={c('label-date')}>
                                  {study.date}
                                </div>

                                <div className={c('text-study')}>
                                  &nbsp;&nbsp;{study.study}
                                </div>
                                <Grid
                                  item
                                  xs={12}
                                  container
                                  justifyContent='center'
                                  style={{ padding: '5px 0px' }}
                                >
                                  <div className={c('container-devider')} />
                                </Grid>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
                <img
                  className={c('student-study-prev')}
                  src={images['student-study-prev.png']}
                  onClick={handleClickStudyPrev}
                  ref={clickAnime}
                />
                <img
                  className={c('student-study-next')}
                  src={images['student-study-next.png']}
                  onClick={handleClickStudyNext}
                  ref={clickAnime}
                />
              </Grid>
            </>
          ) : null}
        </Grid>
        <div style={{ position: 'absolute', bottom: '-4vh', zIndex: 2 }}>
          <ButtonBack />
        </div>
      </Grid>
    </div>
  );
};

export default StudentStudy;
